import React from 'react'
import Body2 from './Body/Body2';



function Template2() {
  return (
    <div>
      
      <Body2/>
      
    </div>
  )
}
export default Template2;

